export class User {
    id = null
    name = null
    email = null
    proAccount = {}
    subDomainCount = null

    constructor (userData) {
        this.id = userData?.id ?? 0;
        this.name = userData?.name ?? '';
        this.email = userData?.email ?? '';
        this.proAccount = userData?.proAccount ?? {};
        this.subDomainCount = userData?.subdomainCount ?? 0;
    }
}
